/**
 * 应用卡片分享
 */
import React, { useCallback, useMemo, useState } from "react";
import { JoySpaceDocumentMessage, SessionType } from "@/types/chat";
import { HeadShowType, MessageSendType } from "@/types/chat/enum";
import lodashGet from "lodash/get";
import styles from "./index.module.less";
import HeadPortrait from "@/baseComponents/Chat/HeadPortrait";
import { openUserCardModal } from "@/components/AddressBook/common";
import Context from "@/components/chat/context";
import ChatState from "@/types/chat/State";
import { getTextMessageRemark } from "@/components/chat/utils/commonMessageModal";
import { connect } from "dva";
import ReferenceHeader from "../ReferenceHeader";

function mapStateToProps({ chat }: { chat: ChatState }) {
  const { currentEmployee, selectedSession, connectState } = chat;
  return {
    userInfo: currentEmployee,
    currentEmployee,
    selectedSession,
    connectState
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

function CommSummaryCard(props: any) {
  const { currentEmployee, selectedSession, message, sessionType, sendType, onReady } = props;
  const [showMore, setShowMore] = useState<boolean>(false);
  const showFooter = useMemo(() => {
    return (message?.data?.length || 0) > 3 && !showMore;
  }, [message?.data?.length, showMore]);

  // 扩展数据
  const extData = useMemo(() => {
    if (!message?.ext) {
      return {};
    }
    try {
      return typeof message?.ext === "string" ? JSON.parse(message?.ext) : message?.ext;
    } catch (e) {
      return {};
    }
  }, [message?.ext]);

  const aiTitle = useMemo(() => {
    return extData?.ai_type || "";
  }, [extData.ai_type]);

  return (
    <div className={styles["comm-summary-item"]}>
      {aiTitle ? (
        <div className={styles["title"]}>
          <span>使用</span>
          <div className={styles["text"]}>{`「${aiTitle}」`}</div>
        </div>
      ) : null}
      <ReferenceHeader refs={message?.refs} />
      <div
        className={`${styles["content-wrap"]} ${sendType === MessageSendType.OTHER ? "other" : ""}`}
      >
        <div
          className={`top-box ${selectedSession.isSecret ? "top-box_isSecret" : ""}`}
          dangerouslySetInnerHTML={{
            __html: getTextMessageRemark(selectedSession, message, currentEmployee, "", -1).trim()
          }}
        />
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CommSummaryCard);
